import React, {useState} from "react";
import {Box, FormControlLabel, Switch, Tooltip} from "@mui/material";
import {GraphQlDataGrid, nestedValueGetter} from "../../../../components/common/grid/GraphQlDataGrid";
import {graphQLServices} from "../../../../services/GraphQLServices";
import gqlGetCustomerLookup from "../graphql/queries/gqlGetCustomerLookup";
import {GridFilterItem} from "@mui/x-data-grid/models/gridFilterItem";
import {NotInterested} from "@mui/icons-material";
import {translateFunction} from "../../../../localization/TranslationService";

const translate = translateFunction("SureBaseDocuments");

interface ICustomerLookup {
	onRowClick?: (row: any) => void;
	defaultFilter?: GridFilterItem[];
	autoSelectSingleRecord?: boolean;
}

const defaultFilter = [
	{
		field: "customer.id",
		operator: "startsWith",
	},
	{
		field: "customer.naamSamengesteld",
		operator: "startsWith",
	},
	{
		field: "customer.plaats",
		operator: "startsWith",
	},
	{
		field: "customer.postcode",
		operator: "startsWith",
	},
	{
		field: "customer.emailadres",
		operator: "startsWith",
	},
	{
		field: "broker.name",
		operator: "startsWith",
	},
];

export const CustomerLookup: React.FC<ICustomerLookup> = (props) => {
	const [activeOnly, setActiveOnly] = useState<boolean>(false);
	const filter = defaultFilter.filter((it) => props.defaultFilter && (props.defaultFilter.filter((x) => x.field === it.field  ).length === 0));

	return (
		<Box>
			<FormControlLabel control={
				<Switch name="Inactief" checked={!activeOnly} onChange={() => setActiveOnly(!activeOnly)} />
			} label="Inclusief inactief"/>

			<GraphQlDataGrid
				enableHeaderFilter
				hideExportButton
				client={graphQLServices.documentsClient}
				query={
					gqlGetCustomerLookup
				}
				defaultSortModel={[
					{
						field: "customer.id",
						sort: "asc"
					}
				]}
				defaultFilterModel={{
					items: [...filter??[],...props.defaultFilter??[]]
				}}

				columns={[
					{
						field: "active",
						headerName: translate("Active"),
						
						valueGetter: nestedValueGetter,
						width: 80,
						sortable: false,
						filterable: false,
						type: "boolean",
						renderCell: (params) => {
							return (
								<>
									{!params.row.active && <Tooltip title={translate("Inactive")}><NotInterested/></Tooltip>}
								</>
							);
						},
					},
					{
						field: "customer.id",
						headerName: "Nr",
						valueGetter: nestedValueGetter,
						width: 130,
						sortable: true,
					},
					{
						field: "customer.naamSamengesteld",
						headerName: "Name",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 300,
						sortable: true,
					},
					{
						field: "customer.plaats",
						headerName: "City",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 150,
						sortable: true,
					},
					{
						field: "customer.postcode",
						headerName: "Zipcode",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 130,
						sortable: true,
					},
					{
						field: "customer.straat",
						headerName: "Street",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 130,
						sortable: true,
					},
					{
						field: "customer.huisnummer",
						headerName: "Housenumber",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 130,
						sortable: true,
					},

					{
						field: "customer.emailadres",
						headerName: "Email",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 300,
						sortable: true,
					},
					{
						field: "broker.naam",
						headerName: translate("Broker"),
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 300,
						sortable: true,
					},
				
				]}
				graphFunction={	"customersLookup" }
				rows={[]}
				getRowId={(item:any)=> item.customer.id}
				initialPageSize={10}
				rowsPerPageOptions={[5, 10, 20]}
				autoHeight={true}
				//disableColumnFilter
				//disableColumnMenu
				onRowClick={(params) => props.onRowClick && props.onRowClick(params.row)}
				autoSelectSingleRecord={props.autoSelectSingleRecord}
				onAutoSelect={(row) => props.onRowClick && props.onRowClick(row)}
				queryVariables={{"activeOnly": activeOnly}}
			/>

		</Box>
	);
};
